var customShape = {'A': 4.44, 'E': 29000, 'Fy': 50, 'Ix': 48, 'Sx': 11.8, 'Name': "Custom Shape", 'W': 15, 'Type': 'Custom'};

var customAluminumShapes = [
    {'Name': '6.5" Aluminum Joist', 'A': 2.7, 'Ix': 17, 'Sx': 5.23, 'W': 4.0, 'Type': 'Custom Aluminum', 'Mn': 94, 'Vn': 6.17, 'E': 10200, 'Fy': 18},
    {'Name': '7.5" Aluminum Stringer', 'A': 3.54, 'Ix': 34.82, 'Sx': 8.769, 'W': 5.2, 'Type': 'Custom Aluminum', 'Mn': 158, 'Vn': 14.8, 'E': 10200, 'Fy': 18},
    {'Name': 'HV Main Beam', 'A': 4.21, 'Ix': 14.16, 'Sx': 3.64, 'W': 5.11, 'Type': 'Custom Aluminum', 'Mn': 66, 'Vn': 5.93, 'E': 10200, 'Fy': 18},
    {'Name': 'HV Secondary Beam', 'A': 1.4, 'Ix': 4.21, 'Sx': 1.77, 'W': 2.1, 'Type': 'Custom Aluminum', 'Mn': 32, 'Vn': 2.04, 'E': 10200, 'Fy': 18},
    {'Name': 'ICS Stringer 225', 'A': 5.06, 'Ix': 54, 'Sx': 12.16, 'W': 5.72, 'Type': 'Custom Aluminum'},
    
    
];

var customSoldierShapes = [
    {'Name': 'Continuous Single Member', 'A': 4, 'Ix': 56.5, 'Sx': 12.56, 'Iy': 27.5, 'Sy': 6.12, 'W': 20.0, 'Type': 'Dayton Superior Soldier', 'Mn': 314, 'Vn': 25, 'E': 29000, 'Fy': 25},
    {'Name': 'Two Continuous Stacked', 'A': 8, 'Ix': 270, 'Sx': 30, 'Iy': 55, 'Sy': 12.24, 'W': 40.0, 'Type': 'Dayton Superior Soldier', 'Mn': 750, 'Vn': 40, 'E': 29000, 'Fy': 25},
    {'Name': 'Double C5 x 6.7', 'A': 3.94, 'Ix': 14.98, 'Sx': 6, 'W': 13.4, 'Type': 'Dayton Superior Soldier', 'Mn': 108, 'Vn': 25, 'E': 29000, 'Fy': 25},
    {'Name': '5" Versiform Waler', 'A': 3.94, 'Ix': 14.95, 'Sx': 5.98, 'Iy': 1.86, 'Sy': 0.744, 'W': 13.4, 'Type': 'Dayton Superior Soldier', 'Mn': 108, 'Vn': 18, 'E': 29000},
    {'Name': '8" Versiform Waler', 'A': 6.74, 'Ix': 65, 'Sx': 16.28, 'Iy': 6.2, 'Sy': 1.55, 'W': 23.0, 'Type': 'Dayton Superior Soldier', 'Mn': 293, 'Vn': 18, 'E': 29000}
];

function showCustomShapeDialog() {
    $('#modal-custom-shape-dialog').modal('show');
}

function hideCustomShapeDialog() {
    $('#modal-custom-shape-dialog').modal('hide');
}

function openDeleteCustomShapeDialog(shapeKey) {
    $('#modal-delete-custom-shape-dialog').modal('show');
}


function getCustomShapes() {
    getCustomShapesFromDatabaseAndUpdateCustomShapeList();
    loadCustomShapesTable([]);
}

function saveNewCustomShape() {
    var shape = {

    }
    writeCustomShape(shape);
}

function writeCustomShape(shape) {
    if(firebase.auth().currentUser === null) {
        return;
    }
    var uid = firebase.auth().currentUser.uid;

    var shapes = {};

    if(shape.key === undefined || shape.key === null) {
        var newShapeKey = firebase.database().ref().child('custom-shapes').push().key;
        shape.key = newShapeKey;
    }

    shapes['/custom-shapes/' + uid + '/beam-designer/' + shape.key] = shape;
    hideCustomShapeDialog();
    return firebase.database().ref().update(shapes);
}

function getCustomShapesFromDatabaseAndUpdateCustomShapeList() {
  if(firebase.auth().currentUser === null) {
      return;
  }
  var uid = firebase.auth().currentUser.uid;
  firebase.database().ref('custom-shapes/' + uid + '/beam-designer')
    .limitToLast(100).once('value').then(function(snapshot) {
      customShapes = {};
      snapshot.forEach(function(childSnapshot) {
          var childKey = childSnapshot.key;
          var childData = childSnapshot.val();
          customShapes[childKey] = childData
      });
      loadCustomShapesTable();
    });
}

function loadCustomShapesInputTable() {

    let useCustomShape = activeProject.isCustom

    $('#use-custom-shape-checkbox').removeClass('d-none');
    document.getElementById("use-custom-shape").checked = useCustomShape;
    if(useCustomShape) {
        customShape = activeProject.shape;
        $('#use-custom-shape-label').removeClass("text-muted");
        $("#shape-table").removeClass("text-muted");
        $('#custom-shapes-tab a[href="#custom-shapes"]').tab('show');
        $('#custom-shapes-sub-tab').tab('show');
    } else {
        $('#use-custom-shape-label').addClass("text-muted");
        $("#shape-table").addClass("text-muted");
    }

    var str = "<div id='custom-shape-input-form' class='form-control'>";

    str += '<div class="mb-3">';
    str += '<label for="custom-shape-name">Name</label>';
    str += '<input type="text" id="custom-shape-name" onchange="updateCustomShapeProperties();" value="' + customShape["Name"] + '">';
    str += '</div>';

    str += '<div class="mb-3">';
    str += '<label for="custom-shape-moment-of-inertia">Moment of Inertia, Ixx (in<sup>4</sup>)</label>';
    str += '<input type="text" class="form-control" id="custom-shape-moment-of-inertia" onchange="updateCustomShapeProperties();" value="' + customShape["Ix"] + '">';
    str += '</div>';

    str += '<div class="input-group mb-3">';
    str += '<label for="custom-shape-section-modulus">Section Modulus, Sx (in<sup>3</sup>)</label>';
    str += '<input type="text" class="form-control" id="custom-shape-section-modulus" aria-describedby="basic-addon3" onchange="updateCustomShapeProperties();" value="' + customShape["Sx"] + '">';
    str += '</div>';


    str += '<div class="input-group mb-3">';
    str += '<label for="custom-shape-area">Area, A (in<sup>2</sup>)</label>';
    str += '<input type="text" class="form-control" id="custom-shape-area" aria-describedby="basic-addon3" onchange="updateCustomShapeProperties();" value="' + customShape["A"] + '">';
    str += '</div>';

    str += '<div class="input-group mb-3">';
    str += '<label for="custom-shape-weight">Weight, W (lb/ft)</label>';
    str += '<input type="text" class="form-control" id="custom-shape-weight" aria-describedby="basic-addon3" onchange="updateCustomShapeProperties();" value="' + customShape["W"] + '">';
    str += '</div>';

    str += '<div class="input-group mb-3">';
    str += '<label for="custom-shape-modulus-of-elasticity">Modulus of Elasticity, E (ksi)</label>';
    str += '<input type="text" class="form-control" id="custom-shape-modulus-of-elasticity" aria-describedby="basic-addon3" onchange="updateCustomShapeProperties();" value="' + customShape["E"] + '">';
    str += '</div>';

    str += '<div class="input-group mb-3">';
    str += '<label for="custom-shape-yield-stress">Tensile Yield Stress, Fy (ksi)</label>';
    str += '<input type="text" class="form-control" id="custom-shape-yield-stress" aria-describedby="basic-addon3" onchange="updateCustomShapeProperties();" value="' + customShape["Fy"] + '">';
    str += '</div>';
    str += '</div>';

    $("#shape-table").html(str);
}

function onUseCustomShapeClick() {
    if(customerGate()) { 
        $('#modal-shape-selector-dialog').modal('hide');
        return; 
    }
    var useCustomShape = $('#use-custom-shape:checked').val() !== undefined;
    if(useCustomShape) {
        $('#use-custom-shape-label').removeClass("text-muted");
        $("#shape-table").removeClass("text-muted");
        const customEvent = new CustomEvent('custom-shape-selected', { detail: getCustomShapeFromForm() })
        document.dispatchEvent(customEvent)
    } else {
        const customEvent = new CustomEvent('custom-shape-unselected')
        document.dispatchEvent(customEvent)
    }
}

function getCustomShapeFromForm() {
    customShape["Name"] = $('#custom-shape-name').val()
    customShape['Ix'] = parseFloat($('#custom-shape-moment-of-inertia').val());
    customShape['Sx'] = parseFloat($('#custom-shape-section-modulus').val());
    customShape['A'] = parseFloat($('#custom-shape-area').val());
    customShape['W'] = parseFloat($('#custom-shape-weight').val());
    customShape['E'] = parseFloat($('#custom-shape-modulus-of-elasticity').val());
    customShape['Fy'] = parseFloat($('#custom-shape-yield-stress').val());
    customShape['Type'] = 'Custom';
    return customShape;
}
function updateCustomShapeProperties() {
    customShape["Name"] = $('#custom-shape-name').val()
    customShape['Ix'] = parseFloat($('#custom-shape-moment-of-inertia').val());
    customShape['Sx'] = parseFloat($('#custom-shape-section-modulus').val());
    customShape['A'] = parseFloat($('#custom-shape-area').val());
    customShape['W'] = parseFloat($('#custom-shape-weight').val());
    customShape['E'] = parseFloat($('#custom-shape-modulus-of-elasticity').val());
    customShape['Fy'] = parseFloat($('#custom-shape-yield-stress').val());
    var useCustomShape = $('#use-custom-shape:checked').val() !== undefined;
    if(useCustomShape) {
        const customEvent = new CustomEvent('custom-shape-selected', { detail: customShape })
        document.dispatchEvent(customEvent)
    }
}

function editCustomShape(key) {
    var shape = customShapes[key];
    console.log("edit");
    console.log(shape);
}

function deleteCustomShape(key) {
    var shape = customShapes[key];
    console.log("delete");
    console.log(shape);
}

function customShapeSelected(key) {
    var shape = customShapes[key];
    console.log("selected");
    console.log(shape);
}
